import type { CoupangReviewState } from './types';

export const COUPANG_REVIEW_FAILURE_QUERY_KEYS = {
  list: (state: CoupangReviewState, limit: number, cursor?: string) =>
    ['coupang-review-failures', state, limit, cursor ?? ''] as const,
};
